export default __webpack_public_path__ + "static/media/lock-24px.e90070ba.svg";